import React from 'react';
import { STATUS_LABELS, dayLong, num } from './weeklyPlanUtils';

const OrderBlock = ({ order }) => (
  <div className="rounded-md border border-zinc-200 bg-white px-3 py-2" data-testid={`wp-order-${order.id}`}>
    <div className="flex flex-wrap items-baseline justify-between gap-2">
      <div className="text-sm font-medium text-zinc-900">
        {order.customer_name} <span className="font-mono text-xs text-zinc-400">#{order.dispatch_number}{order.po_number ? ` · PO ${order.po_number}` : ''}</span>
      </div>
      <div className="text-xs text-zinc-500">
        <span className="font-mono font-semibold text-zinc-900">{num(order.units, 1)} units</span> · {num(order.cases, 1)} cs · {num(order.weight, 1)} kg · {order.vehicle_info || '—'} · {STATUS_LABELS[order.status] || order.status}
      </div>
    </div>
    <ul className="mt-1 text-xs text-zinc-600 grid sm:grid-cols-2 gap-x-6">
      {order.lines.map((ln) => (
        <li key={ln.product_name} className="flex justify-between gap-3">
          <span className="truncate">{ln.product_name}</span><span className="font-mono text-zinc-900">{num(ln.units, 1)}</span>
        </li>
      ))}
    </ul>
  </div>
);

export const WeekOrdersByDay = ({ week, onlyDay }) => {
  const days = week.days.filter((d) => d.orders.length && (!onlyDay || d.date === onlyDay));
  if (!days.length) return <p className="text-sm text-muted-foreground py-4" data-testid="wp-orders-empty">No orders {onlyDay ? 'on this day' : 'this week'}.</p>;
  return (
    <div className="space-y-4" data-testid="wp-orders-by-day">
      {days.map((d) => (
        <div key={d.date} data-testid={`wp-orders-day-${d.date}`}>
          <div className="flex items-baseline justify-between border-l-4 border-[#005F73] bg-[#005F73]/5 px-3 py-1.5 rounded-r">
            <span className="text-sm font-semibold">{dayLong(d.date)}</span>
            <span className="text-xs text-zinc-600"><b className="font-mono text-zinc-900">{num(d.units, 1)}</b> units · {d.order_count} orders · {num(d.cases, 1)} cs</span>
          </div>
          <div className="mt-2 space-y-1.5">{d.orders.map((o) => <OrderBlock key={o.id} order={o} />)}</div>
        </div>
      ))}
    </div>
  );
};
